export default () => ({
	isMegamenuOpen: false,
	isScrolled: false,
	showMenu: true,
	lastScrollPos: 0,
	isThereTags: false,
	tagsOffsetTop: 0,
	cache: {
		root: null,
	},
	toggleMegamenu() {
		this.isMegamenuOpen = !this.isMegamenuOpen;
	},
	closeMegamenu() {
		this.isMegamenuOpen = false;
	},
	updateHeight() {
		if (this.cache.root) {
			this.cache.root.style.setProperty(
				'--nav-height',
				this.$refs.header.offsetHeight / 16 + 'rem'
			);
		}
	},
	toggleMenuVisibility() {
		const currentScrollPos = window.scrollY;
		const pageTagsContainer = document.getElementById("listing-page-tags");
		if(!pageTagsContainer) return;

		//check if currentScrollPos is bigger than the pageTagsContainer's top position
		if(currentScrollPos <= pageTagsContainer.offsetTop){
			pageTagsContainer.style.paddingBottom = "0px"
			pageTagsContainer.style.paddingTop = "0px"
		}

		// console.log('currentScrollPos', currentScrollPos);
		// console.log('pageTagsContainer.offsetTop', this.tagsOffsetTop);

		if(currentScrollPos > this.tagsOffsetTop) {
			this.showMenu = currentScrollPos <= this.lastScrollPos;
			pageTagsContainer.style.paddingBottom = "10px"
			pageTagsContainer.style.paddingTop = "10px"
		}else{
			this.showMenu = true;
		}

		if(this.showMenu){
			pageTagsContainer.style.top = "calc(var(--nav-height) + var(--announcement-height))";
		}else{
			pageTagsContainer.style.top = "0";
		}

		this.lastScrollPos = currentScrollPos;
	},
	updateScroll() {
		this.isScrolled = window.scrollY > 100;
		this.scrollPos = window.scrollY;
		// console.log(window.scrollY);
		this.toggleMenuVisibility();
	},
	mainProps: {
		['@scroll.window.throttle.100ms.debounce.100ms']() {
			this.updateScroll();
		},
		['@resize.window.throttle.100ms.debounce.100ms']() {
			this.updateHeight();
		},
		['x-init']() {
			this.cache.root = document.querySelector(':root');
			this.$nextTick(() => this.updateHeight());
			setTimeout(() => this.updateHeight(), 400);
			this.updateScroll();
		},
	},

	// Search

	searchOpen: false,
	searchText: '',
	isLoading: false,
	emptyResults: {
		products: [],
		documents: [],
		blogPosts: [],
	},
	results: {
		products: [],
		documents: [],
		blogPosts: [],
	},
	history: [],
	newHistoryItem(item) {
		if (typeof item !== 'string' || item.length < 3) {
			return;
		}
		if (this.history.includes(item)) {
			this.history = this.history.filter((i) => i !== item);
		} else if (this.history.length >= 10) {
			this.history = this.history.slice(1, 10);
		}
		this.history = [item, ...this.history];
		localStorage.setItem(
			'headerSearchHistory',
			JSON.stringify(this.history)
		);
	},
	clearHistory() {
		this.history = [];
		localStorage.setItem(
			'headerSearchHistory',
			JSON.stringify(this.history)
		);
	},
	redirect() {
		if (this.searchText.length < 3) {
			return;
		}
		this.newHistoryItem(this.searchText);
		window.location.href = `/kereses?s=${this.searchText}`;
	},
	search() {
		this.isLoading = true;
		if (this.searchText.length < 3) {
			this.results = this.emptyResults;
			this.isLoading = false;
			return;
		}
		this.newHistoryItem(this.searchText);
		this.getResults();
	},
	getResults() {
		this.isLoading = true;

		fetch('/api/search/quick?s=' + this.searchText, {
			method: 'GET',
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.results = data.data;
				this.isLoading = false;
			})
			.catch((_error) => {
				this.results = this.emptyResults;
				this.isLoading = false;
			});
	},
	historyToUrl(searchPhrase) {
		return '/kereses?s=' + searchPhrase;
	},
	init() {
		this.history =
			JSON.parse(localStorage.getItem('headerSearchHistory')) || [];

		const pageTagsContainer = document.getElementById("listing-page-tags");
		if(!pageTagsContainer) return;
		this.isThereTags = true;
		this.tagsOffsetTop = pageTagsContainer.offsetTop;
	},

	// Login button

	isDistributorDropdownOpen: false,
});
